import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    console.info('[ProtectedRoute] Checking authentication state...');
    return <div>Loading...</div>; // Replace with your loading spinner/component
  }

  if (!user) {
    console.warn('[ProtectedRoute] User is not authenticated. Redirecting to home.');
    return <Navigate to="/" replace />;
  }

  console.info('[ProtectedRoute] User is authenticated. Rendering protected content.');
  return children;
};

export default ProtectedRoute;
